'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    min-width: 0;\n    &&& {\n      width: 90%;\n      margin: 0 auto;\n    }\n    > div {\n      flex-direction: column;\n    }\n  '], ['\n    min-width: 0;\n    &&& {\n      width: 90%;\n      margin: 0 auto;\n    }\n    > div {\n      flex-direction: column;\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    &&& {\n      width: 100%;\n    }\n  '], ['\n    &&& {\n      width: 100%;\n    }\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    padding-right: 60px;\n    padding-left: 60px;\n  '], ['\n    padding-right: 60px;\n    padding-left: 60px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    padding-right: 30px;\n    padding-left: 30px;\n  '], ['\n    padding-right: 30px;\n    padding-left: 30px;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    text-align: center;\n  '], ['\n    text-align: center;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    width: 100%;\n    text-align: center;\n  '], ['\n    width: 100%;\n    text-align: center;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    border-right: none;\n    margin-top: 85px;\n    padding-left: 60px;\n  '], ['\n    border-right: none;\n    margin-top: 85px;\n    padding-left: 60px;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    margin-top: 30px;\n    padding-left: 30px;\n    padding-right: 30px;\n  '], ['\n    margin-top: 30px;\n    padding-left: 30px;\n    padding-right: 30px;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    width: 50%;\n    margin-left: auto;\n    margin-right: auto;\n  '], ['\n    width: 50%;\n    margin-left: auto;\n    margin-right: auto;\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SkeletonLoadWrapper = require('pricing-pages-unified-ui/components/loading/SkeletonLoadWrapper');

var _SkeletonLoadWrapper2 = _interopRequireDefault(_SkeletonLoadWrapper);

var _colors = require('HubStyleTokens/colors');

var _responsiveBreakpoints = require('pricing-pages-unified-ui/utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _UICardWrapper = require('UIComponents/card/UICardWrapper');

var _UICardWrapper2 = _interopRequireDefault(_UICardWrapper);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _CurrentPlanTag = require('pricing-pages-unified-ui/components/common/CurrentPlanTag');

var _CurrentPlanTag2 = _interopRequireDefault(_CurrentPlanTag);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledCardWrapper = (0, _styledComponents2.default)(_UICardWrapper2.default).withConfig({
  displayName: 'HorizontalMerchCard__StyledCardWrapper'
})(['border:1px solid ', ';background-color:', ';min-height:500px;', ';', ';'], _colors.BATTLESHIP, _colors.OLAF, _responsiveBreakpoints2.default.tablet(_templateObject), _responsiveBreakpoints2.default.phone(_templateObject2));

var BizObjectivesSection = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'HorizontalMerchCard__BizObjectivesSection'
})(['height:100%;text-align:left;', ';', ';'], _responsiveBreakpoints2.default.tablet(_templateObject3), _responsiveBreakpoints2.default.phone(_templateObject4));

var TitleWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'HorizontalMerchCard__TitleWrapper'
})(['font-size:32px;font-weight:600;line-height:44px;text-align:left;display:block;', ';'], _responsiveBreakpoints2.default.tablet(_templateObject5));

var DescriptionWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'HorizontalMerchCard__DescriptionWrapper'
})(['height:72px;width:250px;font-size:14px;margin-top:9px;text-align:left;display:block;', ';'], _responsiveBreakpoints2.default.tablet(_templateObject6));

var ProductInfoSection = _styledComponents2.default.div.withConfig({
  displayName: 'HorizontalMerchCard__ProductInfoSection'
})(['height:100%;padding:0 50px 0 90px;border-right:1px solid ', ';', ';', ';'], _colors.GREAT_WHITE, _responsiveBreakpoints2.default.tablet(_templateObject7), _responsiveBreakpoints2.default.phone(_templateObject8));

var StyledCTAsWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'HorizontalMerchCard__StyledCTAsWrapper'
})(['margin:30px 0;width:90%;text-align:center;button,a{width:100%;line-height:23px;}', ';', ';'], _responsiveBreakpoints2.default.tablet(_templateObject9), _responsiveBreakpoints2.default.tabletPortrait(_templateObject10));

var HorizontalMerchCard = function HorizontalMerchCard(_ref) {
  var ProductTitle = _ref.ProductTitle,
      ProductDescription = _ref.ProductDescription,
      SeeAllFeaturesSection = _ref.SeeAllFeaturesSection,
      PriceDisplay = _ref.PriceDisplay,
      BizObjectives = _ref.BizObjectives,
      CTAs = _ref.CTAs,
      purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus,
      ownsProduct = _ref.ownsProduct;

  return _react2.default.createElement(
    StyledCardWrapper,
    { className: 'm-top-10' },
    ownsProduct && _react2.default.createElement(_CurrentPlanTag2.default, null),
    _react2.default.createElement(
      _UIFlex2.default,
      { align: 'center', justify: 'center' },
      _react2.default.createElement(
        ProductInfoSection,
        null,
        _react2.default.createElement(
          TitleWrapper,
          null,
          ProductTitle
        ),
        _react2.default.createElement(
          DescriptionWrapper,
          null,
          ProductDescription
        ),
        _react2.default.createElement(
          _SkeletonLoadWrapper2.default,
          {
            isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED,
            widths: [70],
            heights: [30]
          },
          PriceDisplay
        ),
        _react2.default.createElement(
          StyledCTAsWrapper,
          null,
          _react2.default.createElement(
            _SkeletonLoadWrapper2.default,
            {
              isLoading: purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED,
              heights: [50]
            },
            CTAs
          )
        )
      ),
      _react2.default.createElement(
        BizObjectivesSection,
        {
          direction: 'column',
          justify: 'center',
          align: 'center'
        },
        BizObjectives
      )
    ),
    SeeAllFeaturesSection
  );
};

HorizontalMerchCard.propTypes = {
  ProductTitle: _react.PropTypes.node.isRequired,
  ProductDescription: _react.PropTypes.node.isRequired,
  PriceDisplay: _react.PropTypes.node.isRequired,
  BizObjectives: _react.PropTypes.node.isRequired,
  CTAs: _react.PropTypes.node.isRequired,
  SeeAllFeaturesSection: _react.PropTypes.node,
  ownsProduct: _react.PropTypes.bool,
  purchaseMotionRequestStatus: _react.PropTypes.string.isRequired
};

exports.default = HorizontalMerchCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/HorizontalMerchCard.js
// module id = 622
// module chunks = 3 4